<script lang="ts">
  import AutoComplete from '$shared/atoms/AutoComplete/AutoComplete.svelte';
  import { countryData } from '$provider/lib/datas/CountryData';
  import Label from '$shared/constants/Label';
  import { onMount } from 'svelte';

  const countryList = countryData.getAsCommonList();

  interface Props {
    value?: string;
    useLabel?: boolean;
    onchange?: (detail: string | CommonList) => void;
  }

  let { value = '', useLabel = false, onchange }: Props = $props();

  let selectedCountryLabel: string = $state('');

  onMount(() => {
    value && (selectedCountryLabel = useLabel ? value : countryData.getLabel(value));
  });

  const onCountrySelect = (detail: CommonList): void => {
    selectedCountryLabel = detail.label;
    onchange?.(useLabel ? detail.label : detail);
  };

  const onCountryCleared = (): void => {
    selectedCountryLabel = '';
    onchange?.('');
  };
</script>

<AutoComplete
  list={countryList}
  value={selectedCountryLabel}
  placeholder={Label.Country}
  onclick={onCountrySelect}
  oncleared={onCountryCleared}
/>
